export default __webpack_public_path__ + "c048966e0e698617eb2ef501918f7888.png";